import {
  AfterViewInit,
  Component,
  ComponentFactoryResolver,
  ComponentRef, OnDestroy,
  OnInit,
  ViewChild,
  ViewContainerRef,
  ViewEncapsulation
} from '@angular/core';
import {language} from '../../../language/vn';
import {VanBanDenChoGiaoXLComponent} from '../vanbanden/chogiaoxuly/chogiaoxuly.component';
import {VanBanDenDaVaoSoComponent} from '../vanbanden/davaoso/davaoso.component';
import {VanBanDiChoGiaoXLComponent} from './chogiaoxuly/chogiaoxuly.component';
import {VanBanDiTongHopComponent} from './tonghop/tonghop.component';
import {SoanVanBanDiComponent} from './soanvanban/create.component';
import {XuLyVanBanDiComponent} from './xulyvanban/xuly.component';
import {QLPhoCapVanBanDiComponent} from './quanlyphocap/phocap.component';
import {VanBanDiDaVaoSoComponent} from './davaoso/davaoso.component';
import {environment} from '../../../../environments/environment';
import {CommandUtil} from '../../../global/commandutil';
import {Sessioncommand} from '../../../global/sessioncommand';
import {VanBanDiService} from '../../../service/vanbandi/service-vanbandi';
import {SVTVanBanDiComponent} from './quanlyso/so.component';
import {ActivatedRoute} from '@angular/router';
import {DuocXemVanBanDiComponent} from './duocxem/duocxem.component';
import {NavItemService} from '../../../service/staff/service-navitem';
import {RolePermissionService} from '../../../service/security/service-rolepermission';
import {InSoCongVanDenComponent} from '../vanbanden/insocv/insocv.component';
import {InSoCongVanDiComponent} from './insocv/insocv.component';
import {BsModalService} from 'ngx-bootstrap/modal';


@Component({
  templateUrl: './vanbandi.component.html',
  encapsulation: ViewEncapsulation.None
})
export class VanBanDiComponent implements OnInit, AfterViewInit, OnDestroy {
  public totalChuaXuLy: number = 0;
  public totalDangXuLy: number = 0;
  public totalHoanThanh: number = 0;
  public totalChuaXem: number = 0;
  public totalDuocXem: number = 0;
  public totalPhoCap: number = 0;
  public totalChuaPhoCap: number = 0;
  public totalChoGiaoXuLy: number = 0;
  public totalDaVaoSo: number = 0;
  public viewTotalInternal;
  public permissionVaoSo: boolean = false;
  public permissionChoGiaoXuLy: boolean = false;
  public permissionDaVaoSo: boolean = false;
  public permissionInSoCV: boolean = false;
  public permissionQLSo: boolean = false;
  public permissionVBDXuLy: boolean = false;
  public permissionVBDDuocXem: boolean = false;
  public permissionQLPhoCap: boolean = false;

  public  colMain: string = 'col-md-9';
  public  titleCard: string = language.vanbandi;
  public status: number[] = [
    environment.chogiaoxuly
  ];
  public phoCap: number = -1;
  public nguoiNhapId: number = Sessioncommand.staffId;
  public nguoiGiaoXuLy: number = Sessioncommand.staffId;
  public nguoiChuTri: number =-1;
  public maNoiGui: number =-1;
  public language = language;
  @ViewChild('container', { read: ViewContainerRef })
  public viewContainerRef: ViewContainerRef;
  public showRef: ComponentRef<Object>;
  constructor(public componentFactoryResolver: ComponentFactoryResolver,
              public vanBanDiService: VanBanDiService,
              public route: ActivatedRoute,
              public navItemService: NavItemService,
              public bsModalService: BsModalService,
              public rolePermissionService: RolePermissionService
  ) {
  }
  public showComponent(component)
  {
    const viewRef =  this.viewContainerRef;
    viewRef.clear();
    const factory = this.componentFactoryResolver.resolveComponentFactory(component);
    const comRef = viewRef.createComponent(factory);
    this.showRef = comRef;
  }
  public changeColMain()
  {
    if(this.colMain === 'col-md-9')
      this.colMain= 'col-md-12';
    else
      this.colMain= 'col-md-9';
  }
  ngAfterViewInit() {
    this.route.queryParams.
    subscribe(params => {
      if (params.ty == null)
        this.showTongHop();
      else {
        if(params.ty == 'cgxl')
          this.showChoGXL();
        if(params.ty == 'dvso')
          this.showDaVaoSo();
        if(params.ty == 'xl')
             this.showXuLy(params.st);
        if(params.ty == 'pc')
          this.showPhoCap();
        if(params.ty == 'vs')
          this.showVaoSo();
      }
    });
    this.loadTotal();
    this.viewTotalInternal= setInterval(() => {
      if (Sessioncommand.vanBanDiStatus === 0 )
        this.loadTotal();
    }, 2000);
  }
  public showVaoSo() {
    this.titleCard = language.vaosovanbandi;
    this.showComponent(SoanVanBanDiComponent);

  }
  public showVBDuocXem() {
    this.colMain = 'col-md-12';
    this.titleCard = language.vanbandiduocxem;
     this.showComponent(DuocXemVanBanDiComponent);

  }
  public showQuanLySo() {
    this.colMain = 'col-md-12';
    this.titleCard = language.sovanthu;
   this.showComponent(SVTVanBanDiComponent);

  }
  public showPhoCap() {
    this.colMain = 'col-md-12';
    this.titleCard = language.quanlyphocap;
    this.showComponent(QLPhoCapVanBanDiComponent);

  }
  public showXuLy(status : string ) {
    this.colMain = 'col-md-12';
    this.titleCard = language.xulyvanbandi;
    //this.showComponent(XuLyVanBanDiComponent);
    const viewRef =  this.viewContainerRef;
    viewRef.clear();
    const factory = this.componentFactoryResolver.resolveComponentFactory(XuLyVanBanDiComponent);
    const comRef: ComponentRef<XuLyVanBanDiComponent> = viewRef.createComponent(factory);
    if(status !== undefined)
    comRef.instance.srStatus = status;
    this.showRef = comRef;




  }
  public showTongHop() {

    this.titleCard = language.tonghop;
     this.showComponent(VanBanDiTongHopComponent);
  }
  public showChoGXL() {
    this.colMain = 'col-md-12';
    this.titleCard = language.danhsachvanbandi_chogiaoxuly;
     this.showComponent(VanBanDiChoGiaoXLComponent);

  }
  public showDaVaoSo() {
    this.colMain = 'col-md-12';
    this.titleCard = language.danhsachvanbandi_davaoso;
    this.showComponent(VanBanDiDaVaoSoComponent);
  }
  ngOnInit(): void {
    Sessioncommand.sideBarActive = true;

    this.navItemService.findALlByStaffId(Sessioncommand.staffId, 3, true).subscribe(
      x => {
        this.permissionVaoSo = x.findIndex(y => y.code === 'VBDIVS' ) !== -1;
        this.permissionChoGiaoXuLy = x.findIndex(y => y.code === 'VBDICGXL' ) !== -1;
        this.permissionDaVaoSo = x.findIndex(y => y.code === 'VBDIDVS' ) !== -1;
        this.permissionInSoCV = x.findIndex(y => y.code === 'VBDIINSCV' ) !== -1;
        this.permissionQLSo = x.findIndex(y => y.code === 'VBDIQLS' ) !== -1;
        this.permissionVBDXuLy = x.findIndex(y => y.code === 'VBDIXL' ) !== -1;
        this.permissionVBDDuocXem = x.findIndex(y => y.code === 'VBDIDX' ) !== -1;
        this.permissionQLPhoCap = x.findIndex(y => y.code === 'VBDIQLPC' ) !== -1;
        this.nguoiGiaoXuLy = this.permissionChoGiaoXuLy ? -1 : this.nguoiGiaoXuLy;
        this.vanBanDiService.getCountByKeyword(-1, '',-1,-1, environment.chogiaoxuly.toString(), CommandUtil.defaultValue, this.nguoiGiaoXuLy, this.nguoiChuTri,'','').subscribe(recordCount => this.totalChoGiaoXuLy = recordCount);

      }
    );
  }
  ngOnDestroy() {
    if ( this.viewTotalInternal) {
      clearInterval(this.viewTotalInternal);
    }
  }
  public loadTotal()
  {
    this.nguoiGiaoXuLy = this.permissionChoGiaoXuLy === true? -1: this.nguoiGiaoXuLy;
    this.vanBanDiService.getCountByKeyword(-1, '', -1, -1, environment.chogiaoxuly.toString(), CommandUtil.defaultValue, this.nguoiGiaoXuLy, this.nguoiChuTri,'','').subscribe(recordCount => this.totalChoGiaoXuLy = recordCount);
    this.vanBanDiService.getCountByKeyword(-1, '', -1,-1,'-1', CommandUtil.defaultValue, -1, this.nguoiChuTri,'','').subscribe(recordCount => this.totalDaVaoSo = recordCount);
    this.vanBanDiService.getCountByXLKeyword('', -1, -1, environment.chuaxuly.toString(), CommandUtil.defaultValue, this.nguoiNhapId, this.nguoiChuTri, -1,'','').subscribe(recordCount => this.totalChuaXuLy = recordCount);
    this.vanBanDiService.getCountByXLKeyword('', -1, -1, environment.dangxuly.toString(), CommandUtil.defaultValue, this.nguoiNhapId, this.nguoiChuTri, -1,'','').subscribe(recordCount => this.totalDangXuLy = recordCount);
    this.vanBanDiService.getCountByXLKeyword('', -1, -1, environment.hoanthanh.toString(), CommandUtil.defaultValue, this.nguoiNhapId, this.nguoiChuTri, -1,'','').subscribe(recordCount => this.totalHoanThanh = recordCount);
    this.vanBanDiService.getCountByKeyword(-1, '', -1, -1, '-1', CommandUtil.daPhoCap, this.nguoiNhapId, this.nguoiChuTri,'','').subscribe(recordCount => this.totalPhoCap = recordCount);
    this.vanBanDiService.getCountByKeyword(-1, '', -1, -1,'-1', CommandUtil.chuaPhoCap, this.nguoiNhapId, this.nguoiChuTri,'','').subscribe(recordCount => this.totalChuaPhoCap = recordCount);
    this.rolePermissionService.checkPermissionByModule(Sessioncommand.staffId, "egov.info.vanbandi.duocxem"
    ).subscribe( x => {
      let nId: number = x.findIndex(y => y.action === environment.viewall || y.action === environment.toanquyen) !== -1? -1: this.nguoiNhapId;
      this.vanBanDiService.getCountByRead(-1, '', -1, -1, '-1', -1, -1, -1, nId, '', '').subscribe(recordCount => this.totalDuocXem = recordCount);
    });
    this.vanBanDiService.getCountByXLKeyword('',-1, -1, '-1', CommandUtil.defaultValue, this.nguoiNhapId, this.nguoiChuTri, 0,'','').subscribe(recordCount => this.totalChuaXem = recordCount);
    Sessioncommand.vanBanDiStatus = 1;
  }
  public inSoCongVan() {
    if(this.permissionInSoCV) {
      const modalEdit = this.bsModalService.show(InSoCongVanDiComponent);
      (<InSoCongVanDiComponent>modalEdit.content).edit(
      );
      (<InSoCongVanDiComponent>modalEdit.content).onClose.subscribe(result => {
      });
    }
  }

}

